// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `svg {
  box-sizing: border-box;
}`, "",{"version":3,"sources":["webpack://./src/app/views/emeo-saxophone-v2/emeo-saxophone-v2.component.scss"],"names":[],"mappings":"AAAA;EACI,sBAAA;AACJ","sourcesContent":["svg {\n    box-sizing: border-box;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
